import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const directorBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_REST_API,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('director_token');
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
});

export const directorApi = createApi({
  reducerPath: 'directorApi',
  baseQuery: directorBaseQuery,
  tagTypes: ['DirectorAuth', 'DirectorEvents', 'DirectorFeedback', 'DirectorMe'],
  endpoints: (builder) => ({
    // ── Auth ─────────────────────────────────────────────────────────────────
    directorLogin: builder.mutation({
      query: (body) => ({ url: '/director/auth/login', method: 'POST', body }),
    }),
    directorChangePassword: builder.mutation({
      query: (body) => ({ url: '/director/auth/change-password', method: 'PUT', body }),
    }),
    directorForgotPassword: builder.mutation({
      query: (body) => ({ url: '/director/auth/forgot-password', method: 'POST', body }),
    }),
    directorResetPassword: builder.mutation({
      query: (body) => ({ url: '/director/auth/reset-password', method: 'POST', body }),
    }),

    // ── Me ───────────────────────────────────────────────────────────────────
    getDirectorMe: builder.query({
      query: () => '/director/me',
      providesTags: ['DirectorMe'],
    }),

    // ── Events ───────────────────────────────────────────────────────────────
    getDirectorEvents: builder.query({
      query: () => '/director/events',
      providesTags: ['DirectorEvents'],
    }),
    getDirectorEventDetail: builder.query({
      query: (eventId) => `/director/events/${eventId}`,
      providesTags: (_result, _err, eventId) => [{ type: 'DirectorEvents', id: eventId }],
    }),

    // ── Feedback ─────────────────────────────────────────────────────────────
    getAllEventFeedbacks: builder.query({
      query: () => '/director/feedback',
      providesTags: ['DirectorFeedback'],
    }),
    getDirectorFeedback: builder.query({
      query: (eventId) => `/director/feedback/${eventId}`,
      providesTags: (_result, _err, eventId) => [{ type: 'DirectorFeedback', id: eventId }],
    }),
    saveDirectorFeedback: builder.mutation({
      query: (body) => ({ url: '/director/feedback', method: 'POST', body }),
      invalidatesTags: (_result, _err, { eventId }) => [
        { type: 'DirectorFeedback', id: eventId },
        'DirectorFeedback',
        'DirectorEvents',
      ],
    }),

  }),
});

export const {
  useDirectorLoginMutation,
  useDirectorChangePasswordMutation,
  useDirectorForgotPasswordMutation,
  useDirectorResetPasswordMutation,
  useGetDirectorMeQuery,
  useGetDirectorEventsQuery,
  useGetDirectorEventDetailQuery,
  useGetAllEventFeedbacksQuery,
  useGetDirectorFeedbackQuery,
  useSaveDirectorFeedbackMutation,
} = directorApi;
